import React, { useEffect, useState } from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Drawer } from '@one-thd/sui-atomic-components';
import { MainMenuDrawerBody } from './drawerBodies/MainMenuDrawerBody';
import { DeleteListDrawerBody } from './drawerBodies/DeleteListDrawerBody';
import { ShareListDrawerBody } from './drawerBodies/ShareListDrawerBody';
import { RenameListDrawerBody } from './drawerBodies/RenameListDrawerBody';

const { bool, func, shape, string } = proptypes;

export const ListSettingsDrawer = ({
  open,
  setOpen,
  list,
  onDelete,
  onSave,
  isSharedList,
  isEmptyList
}) => {
  const [menuName, setMenuName] = useState(null);
  const [mainMenuDrawer, setMainMenuDrawer] = useState(true);
  const [renameListDrawer, setRenameListDrawer] = useState(false);
  const [shareListDrawer, setShareListDrawer] = useState(false);
  const [deleteListDrawer, setdeleteListDrawer] = useState(false);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.trigger('ListSettingsDrawer.ready', {});
  }, []);

  const closeDrawer = () => {
    setOpen(false);
  };

  return (
    // The Drawer renders through a React portal to document.body. When this drawer
    // is opened from a themed experience (e.g. the B2B homepage Lists component),
    // the themed --sui-palette-* custom properties set on an ancestor cascade into
    // the portaled drawer and incorrectly theme it. Setting data-sui-palette="light"
    // on the drawer's root re-declares the default light palette on the drawer
    // element itself, overriding the inherited theme. See WOR2-865.
    <Drawer open={open} onClose={closeDrawer} DrawerRootProps={{ 'data-sui-palette': 'light' }}>
      <div data-component="ListSettingsDrawer">
        {mainMenuDrawer && (
          <MainMenuDrawerBody
            open={open}
            list={list}
            onClose={closeDrawer}
            menuName={menuName}
            setMenuName={setMenuName}
            setMainMenuDrawer={setMainMenuDrawer}
            setShareListDrawer={setShareListDrawer}
            setRenameListDrawer={setRenameListDrawer}
            setDeleteListDrawer={setdeleteListDrawer}
            isSharedList={isSharedList}
            isEmptyList={isEmptyList}
          />
        )}
        {shareListDrawer && (
          <ShareListDrawerBody
            open={open}
            list={list}
            onClose={closeDrawer}
            onSave={onSave}
            menuName={menuName}
            setMenuName={setMenuName}
            setMainMenuDrawer={setMainMenuDrawer}
            setShareListDrawer={setShareListDrawer}
          />
        )}
        {deleteListDrawer && (
          <DeleteListDrawerBody
            list={list}
            onDelete={onDelete}
            onClose={closeDrawer}
            menuName={menuName}
            setMenuName={setMenuName}
            setMainMenuDrawer={setMainMenuDrawer}
            setdeleteListDrawer={setdeleteListDrawer}
          />
        )}
        {renameListDrawer && (
          <RenameListDrawerBody
            list={list}
            onClose={closeDrawer}
            setMainMenuDrawer={setMainMenuDrawer}
            menuName={menuName}
            setMenuName={setMenuName}
            setRenameListDrawer={setRenameListDrawer}
            onSave={onSave}
          />
        )}
      </div>
    </Drawer>
  );
};

ListSettingsDrawer.displayName = 'ListSettingsDrawer';

ListSettingsDrawer.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired,
  onDelete: func.isRequired,
  list: shape({
    id: string,
    name: string,
    public: bool
  }).isRequired,
  onSave: func,
  isSharedList: bool,
  isEmptyList: bool
};

ListSettingsDrawer.defaultProps = {
  onSave: () => { },
  isSharedList: false,
  isEmptyList: false
};

ListSettingsDrawer.dataModel = extend(
  MainMenuDrawerBody,
  DeleteListDrawerBody,
  ShareListDrawerBody
);
